export default "__VITE_ASSET__DvdtAX9m__"